document.addEventListener("DOMContentLoaded", () => {
  // ====== SETTINGS (غيرهم براحتك) ======
  const SETTINGS = {
    enableGlow: true,        // لمعة/Glow خفيف
    enablePulse: true,       // نبضة خفيفة
    enableStickyOnMobile: true, // زرار ثابت في الموبايل تحت (اختياري)
    stickyBreakpointPx: 989, // أقل من كده نعتبره موبايل/تابلت
    stickyOffsetTop: 10      // يبدأ يثبت بعد ما تعدي 10px
  };

  // اشتغل بس على صفحات المنتج
  const isProduct =
    document.body.className.includes("template-product") ||
    (window.location.pathname || "").includes("/products/");
  if (!isProduct) return;

  // ====== Inject CSS safely ======
  const css = `
    /* CTA button boost */
    .rr-cta-boost {
      position: relative;
      transform: translateZ(0);
      transition: transform .15s ease, box-shadow .15s ease, filter .15s ease;
      will-change: transform, box-shadow;
    }
    .rr-cta-boost:hover {
      transform: translateY(-1px);
      filter: brightness(1.02);
    }

    /* Glow */
    .rr-cta-glow {
      box-shadow: 0 10px 24px rgba(0,0,0,.18) !important;
    }

    /* Pulse */
    @keyframes rrPulse {
      0%   { transform: translateY(0) scale(1); }
      50%  { transform: translateY(-1px) scale(1.01); }
      100% { transform: translateY(0) scale(1); }
    }
    .rr-cta-pulse {
      animation: rrPulse 1.6s ease-in-out infinite;
    }

    /* Sticky CTA (mobile) */
    .rr-sticky-cta-wrap {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 12px 12px calc(12px + env(safe-area-inset-bottom));
      background: rgba(255,255,255,.92);
      backdrop-filter: blur(8px);
      border-top: 1px solid rgba(0,0,0,.08);
      z-index: 9999;
      display: none;
    }
    .rr-sticky-cta-wrap.rr-show {
      display: block;
    }
    .rr-sticky-cta-wrap button {
      width: 100% !important;
      max-width: 720px;
      margin: 0 auto;
      display: block;
    }
  `;
  const style = document.createElement("style");
  style.setAttribute("data-rr", "cta-boost");
  style.textContent = css;
  document.head.appendChild(style);

  // ====== Find Add to cart button robustly ======
  function findAddToCartButton() {
    // Shopify common patterns
    const candidates = [
      'form[action*="/cart/add"] button[name="add"]',
      'form[action*="/cart/add"] button[type="submit"]',
      'button.product-form__submit',
      'button[name="add"]',
      '[data-add-to-cart]',
      'button[id*="AddToCart"]',
      'button[class*="add-to-cart"]',
    ];

    for (const sel of candidates) {
      const btn = document.querySelector(sel);
      if (btn && btn.offsetParent !== null) return btn;
    }

    // fallback: any visible submit inside a product form
    const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
    for (const f of forms) {
      const btn = f.querySelector('button[type="submit"], input[type="submit"]');
      if (btn && btn.offsetParent !== null) return btn;
    }
    return null;
  }

  const addToCartBtn = findAddToCartButton();
  if (!addToCartBtn) return;

  // ====== Apply boost classes ======
  addToCartBtn.classList.add("rr-cta-boost");
  if (SETTINGS.enableGlow) addToCartBtn.classList.add("rr-cta-glow");
  if (SETTINGS.enablePulse) addToCartBtn.classList.add("rr-cta-pulse");

  // Stop pulsing after user interacts (keeps it classy)
  const stopPulse = () => addToCartBtn.classList.remove("rr-cta-pulse");
  addToCartBtn.addEventListener("mouseenter", stopPulse, { once: true });
  addToCartBtn.addEventListener("focus", stopPulse, { once: true });
  addToCartBtn.addEventListener("click", stopPulse, { once: true });

  // ====== Optional: Sticky CTA on mobile ======
  function enableStickyCTA() {
    const wrap = document.createElement("div");
    wrap.className = "rr-sticky-cta-wrap";
    wrap.setAttribute("data-rr", "sticky-cta");

    const cloneBtn = addToCartBtn.cloneNode(true);
    // ensure clone is a button element
    if (cloneBtn.tagName.toLowerCase() !== "button") return;

    // clicking clone triggers the real button (keeps Shopify logic intact)
    cloneBtn.addEventListener("click", (e) => {
      e.preventDefault();
      addToCartBtn.scrollIntoView({ behavior: "smooth", block: "center" });
      setTimeout(() => addToCartBtn.click(), 250);
    });

    // Remove pulse on sticky (less annoying)
    cloneBtn.classList.remove("rr-cta-pulse");

    wrap.appendChild(cloneBtn);
    document.body.appendChild(wrap);

    const onScroll = () => {
      const isMobile = window.innerWidth <= SETTINGS.stickyBreakpointPx;
      if (!isMobile) {
        wrap.classList.remove("rr-show");
        return;
      }

      const rect = addToCartBtn.getBoundingClientRect();
      const isVisible = rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);

      // show sticky only when original CTA is NOT visible
      if (!isVisible && window.scrollY > SETTINGS.stickyOffsetTop) wrap.classList.add("rr-show");
      else wrap.classList.remove("rr-show");
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    onScroll();
  }

  if (SETTINGS.enableStickyOnMobile) {
    enableStickyCTA();
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const elShape = document.querySelector(".stickit-custom-shape");
  const elSize = document.querySelector(".stickit-custom-size");
  const elQty = document.querySelector(".stickit-custom-qty");

  // زرار Add to cart في Dawn غالبًا واحد من دول
  const addToCartBtn =
    document.querySelector('button[name="add"]') ||
    document.querySelector(".product-form__submit") ||
    document.querySelector('form[action*="/cart/add"] button[type="submit"]');

  if (!addToCartBtn) return;

  // رسالة تحت الزر (هننشئها مرة واحدة)
  let msg = document.querySelector(".stickit-cart-guard");
  if (!msg) {
    msg = document.createElement("div");
    msg.className = "stickit-cart-guard";
    msg.style.display = "none";
    addToCartBtn.insertAdjacentElement("afterend", msg);
  }

  function getSelectedValue(namePrefix) {
    const checkedRadio = document.querySelector(`input[name^="${namePrefix}"]:checked`);
    if (checkedRadio && checkedRadio.value) return checkedRadio.value.trim().toLowerCase();

    const select = document.querySelector(`select[name^="${namePrefix}"]`);
    if (select && select.value) return select.value.trim().toLowerCase();

    return "";
  }

  function setVisible(wrapper, shouldShow) {
    if (!wrapper) return;

    wrapper.classList.toggle("is-visible", shouldShow);
    wrapper.style.display = shouldShow ? "" : "none";

    const input = wrapper.querySelector("input, textarea, select");
    if (!input) return;

    if (shouldShow) {
      input.disabled = false;
    } else {
      input.value = "";
      input.disabled = true;
    }
  }

  function getInputValue(wrapper) {
    if (!wrapper) return "";
    const input = wrapper.querySelector("input, textarea, select");
    if (!input || input.disabled) return "";
    return (input.value || "").trim();
  }

  function guardAddToCart() {
    const shapeVal = getSelectedValue("Shape");
    const sizeVal = getSelectedValue("Size");
    const qtyVal = getSelectedValue("Quantity");

    const shapeCustom = shapeVal === "custom";
    const sizeCustom = sizeVal === "custom";
    const qtyCustom = qtyVal === "custom";

    // إظهار/إخفاء الخانات حسب Custom
    setVisible(elShape, shapeCustom);
    setVisible(elSize, sizeCustom);
    setVisible(elQty, qtyCustom);

    // تحقق من الفاضي
    const missing = [];
    if (shapeCustom && !getInputValue(elShape)) missing.push("Custom Shape");
    if (sizeCustom && !getInputValue(elSize)) missing.push("Custom Size");
    if (qtyCustom && !getInputValue(elQty)) missing.push("Custom Quantity");

    const shouldBlock = missing.length > 0;

    // اقفل/افتح الزر
    addToCartBtn.disabled = shouldBlock;
    addToCartBtn.classList.toggle("is-disabled", shouldBlock);

    // رسالة للمستخدم
    if (shouldBlock) {
      msg.style.display = "block";
      msg.textContent = "Please fill the required custom field(s) before adding to cart.";
    } else {
      msg.style.display = "none";
      msg.textContent = "";
    }
  }

  // تحديث أول مرة
  guardAddToCart();

  // أي تغيير في الاختيارات أو الكتابة في الخانات
  document.addEventListener("change", function (e) {
    if (e.target.matches('input[type="radio"], select, input[type="text"], textarea')) {
      guardAddToCart();
    }
  });

  document.addEventListener("input", function (e) {
    if (e.target.matches("input[type='text'], textarea")) {
      guardAddToCart();
    }
  });

  // لو الثيم بيحدث بالضغط على label
  document.addEventListener("click", function (e) {
    if (e.target.closest("label")) {
      setTimeout(guardAddToCart, 0);
    }
  });
});
window.StickitUploadInit = function () {
  const wrappers = document.querySelectorAll(".stickit-upload");
  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    // امنع التكرار لو Shopify عمل re-render
    if (wrapper.dataset.uploadInit === "1") return;
    wrapper.dataset.uploadInit = "1";

    const box = wrapper.querySelector(".rr-upload-box");
    const input = wrapper.querySelector(".rr-upload-input");
    const warningEl = wrapper.querySelector(".rr-upload-warning");
    const listEl = wrapper.querySelector(".rr-upload-filelist");

    if (!box || !input || !warningEl || !listEl) return;

    // ✅ خلي الرفع اختياري (حتى لو في Liquid مكتوب required)
    input.removeAttribute("required");

    const accepted = (wrapper.dataset.accepted || "")
      .split(",")
      .map((s) => s.trim().toLowerCase())
      .filter(Boolean);

    const maxFiles = parseInt(wrapper.dataset.maxFiles || "5", 10);
    const maxMB = parseFloat(wrapper.dataset.maxMb || "20");
    const maxBytes = maxMB * 1024 * 1024;

    let currentFiles = [];

    const extOk = (fileName) => {
      if (!accepted.length) return true;
      const dot = fileName.lastIndexOf(".");
      if (dot === -1) return false;
      const ext = fileName.slice(dot).toLowerCase(); // includes "."
      return accepted.includes(ext);
    };

    function formatBytes(bytes) {
      const units = ["B", "KB", "MB", "GB"];
      let i = 0;
      let n = bytes;
      while (n >= 1024 && i < units.length - 1) {
        n /= 1024;
        i++;
      }
      return `${n.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
    }

    function setFilesToInput() {
      const dt = new DataTransfer();
      currentFiles.forEach((f) => dt.items.add(f));
      input.files = dt.files;
    }

    function clearUI() {
      warningEl.textContent = "";
      listEl.innerHTML = "";
      box.classList.remove("has-file");
    }

    function render() {
      warningEl.textContent = "";
      listEl.innerHTML = "";

      if (!currentFiles.length) {
        clearUI();
        return;
      }

      currentFiles.forEach((file, idx) => {
        const item = document.createElement("div");
        item.className = "rr-upload-filelist-item";

        // Thumbnail لو صورة
        if (file.type && file.type.startsWith("image/")) {
          const img = document.createElement("img");
          img.className = "rr-upload-thumb";
          const url = URL.createObjectURL(file);
          img.src = url;
          img.onload = () => URL.revokeObjectURL(url);
          item.appendChild(img);
        }

        const meta = document.createElement("div");
        meta.className = "rr-upload-filemeta";

        const name = document.createElement("div");
        name.className = "rr-upload-filename";
        name.textContent = file.name;

        const size = document.createElement("div");
        size.className = "rr-upload-filesize";
        size.textContent = formatBytes(file.size);

        meta.appendChild(name);
        meta.appendChild(size);
        item.appendChild(meta);

        // زر الحذف (يمسح ملف واحد فقط)
        const removeBtn = document.createElement("button");
        removeBtn.type = "button";
        removeBtn.className = "rr-upload-remove";
        removeBtn.textContent = "✕";

        removeBtn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          currentFiles.splice(idx, 1);
          setFilesToInput();
          render();
        });

        item.appendChild(removeBtn);
        listEl.appendChild(item);
      });

      box.classList.add("has-file");
    }

    function validateAndApply(incomingFiles) {
      warningEl.textContent = "";
      const filesArr = Array.from(incomingFiles || []);

      if (!filesArr.length) return;

      // ✅ Replace behavior (مش merge)
      if (filesArr.length > maxFiles) {
        warningEl.textContent = `You can upload up to ${maxFiles} files.`;
        return;
      }

      for (const f of filesArr) {
        if (!extOk(f.name)) {
          warningEl.textContent = `File type not allowed. Allowed: ${accepted.join(", ")}`;
          return;
        }
        if (f.size > maxBytes) {
          warningEl.textContent = `One or more files exceed the max size (${maxMB}MB).`;
          return;
        }
      }

      currentFiles = filesArr;
      setFilesToInput();
      render();

      // allow selecting نفس الملف تاني
      input.value = "";
    }

    // Click box opens picker
    box.addEventListener("click", () => input.click());
    box.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        input.click();
      }
    });

    // Pick files
    input.addEventListener("change", () => {
      validateAndApply(input.files);
    });

    // Drag & drop
    box.addEventListener("dragover", (e) => {
      e.preventDefault();
      box.classList.add("dragging");
    });

    box.addEventListener("dragleave", () => {
      box.classList.remove("dragging");
    });

    box.addEventListener("drop", (e) => {
      e.preventDefault();
      box.classList.remove("dragging");
      if (e.dataTransfer && e.dataTransfer.files) {
        validateAndApply(e.dataTransfer.files);
      }
    });

    // Initial
    render();
  });
};

(function () {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", window.StickitUploadInit);
  } else {
    window.StickitUploadInit();
  }

  document.addEventListener("shopify:section:load", window.StickitUploadInit);
})();
(function () {
  function getPriceEl() {
    // Dawn common selectors
    return document.querySelector(
      ".price .price-item--regular, .price .price-item--sale, .price__regular .price-item, .price__sale .price-item"
    );
  }

  function getForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function parseQtyFromText(txt) {
    if (!txt) return null;
    const m = String(txt).match(/(\d{2,5})/);
    return m ? parseInt(m[1], 10) : null;
  }

  function moneyFromNumberEGP(value) {
    if (!isFinite(value)) return "";
    // عرض نفسي أقوى: شيل .00
    const fixed = (Math.round(value * 100) / 100).toFixed(2);
    const clean = fixed.endsWith(".00") ? fixed.slice(0, -3) : fixed;
    return `EGP ${clean}`;
  }

  function getCurrentTotalPriceNumber() {
    const priceEl = getPriceEl();
    if (!priceEl) return null;
    const txt = priceEl.textContent || "";
    const num = Number(txt.replace(/[^\d.]/g, ""));
    return isFinite(num) ? num : null;
  }

  function getSelectedQty() {
    // حسب شكل عندك: buttons/pills للكمية
    // جرّب يلقط العنصر المحدد
    const active =
      document.querySelector('.quantity [aria-pressed="true"]') ||
      document.querySelector('.quantity .is-selected') ||
      document.querySelector('.quantity .active') ||
      document.querySelector('[data-option-name="Quantity"] .is-selected') ||
      document.querySelector('[data-option-name="Quantity"] .active') ||
      document.querySelector('input[name*="Quantity"]:checked') ||
      document.querySelector('input[type="radio"][name*="quantity"]:checked');

    if (active) return parseQtyFromText(active.textContent || active.value);

    // fallback: من option النص في select id لو عنوانه فيه رقم
    const opt = document.querySelector('select[name="id"] option:checked');
    if (opt) return parseQtyFromText(opt.textContent);

    return null;
  }

  function buildPriceRowOnce() {
    const priceEl = getPriceEl();
    if (!priceEl) return;

    // لو اتبنت قبل كده، خلاص
    if (document.getElementById("stickit-price-row")) return;

    // priceEl غالبًا جوه container
    const priceContainer = priceEl.closest(".price") || priceEl.parentElement;
    if (!priceContainer) return;

    // اعمل row جديدة
    const row = document.createElement("div");
    row.className = "stickit-price-row";
    row.id = "stickit-price-row";

    const main = document.createElement("div");
    main.className = "stickit-main-price";
    main.id = "stickit-main-price";

    // انقل السعر نفسه داخل main (مش نكرر)
    main.appendChild(priceEl);

    const dot = document.createElement("span");
    dot.className = "stickit-dot";
    dot.textContent = "•";

    const unit = document.createElement("div");
    unit.className = "stickit-unit-price";
    unit.id = "stickit-unit-price";
    unit.textContent = "";

    // امسح محتوى priceContainer وحط row بدل ما كان
    // (من غير ما نلمس ملفات core — ده DOM بس)
    priceContainer.innerHTML = "";
    row.appendChild(main);
    row.appendChild(dot);
    row.appendChild(unit);
    priceContainer.appendChild(row);
  }

  function updateUnitPrice() {
    const unitEl = document.getElementById("stickit-unit-price");
    if (!unitEl) return;

    const total = getCurrentTotalPriceNumber();
    const qty = getSelectedQty();

    if (!total || !qty || qty <= 0) {
      unitEl.textContent = "";
      return;
    }

    const per = total / qty;

    // اختيار نفسي: نخليها بدون كسور لو .00
    const txt = moneyFromNumberEGP(per);
    unitEl.textContent = `${txt} / sticker`;
  }

  function init() {
    buildPriceRowOnce();
    updateUnitPrice();
  }

  // تشغيل أولي
  window.addEventListener("load", init);

  // تحديث عند أي تغيير
  document.addEventListener("change", function (e) {
    if (e.target && (e.target.name === "id" || e.target.closest('form[action*="/cart/add"]'))) {
      setTimeout(init, 50);
    }
  });

  // تحديث عند الضغط على أزرار الخيارات (pills)
  document.addEventListener("click", function (e) {
    const t = e.target;
    if (!t) return;

    // لو ضغط على option/quantity pills
    if (
      t.closest(".quantity") ||
      t.closest('[data-option-name="Quantity"]') ||
      t.matches('input[type="radio"]') ||
      t.matches("button")
    ) {
      setTimeout(init, 80);
    }
  });
})();
(function () {
  const SELECTORS = {
    form: 'form[action^="/cart/add"]',
    priceRow: '.stickit-price-row',
    mainPrice: '.stickit-main-price',
    unitPrice: '.stickit-unit-price',
    // محاولات ذكية لالتقاط quantity option
    qtyChecked: 'input[type="radio"][name*="quantity" i]:checked, input[type="radio"][name*="Quantity" i]:checked, input[type="radio"][name*="qty" i]:checked',
    qtySelect: 'select[name*="quantity" i], select[name*="Quantity" i], select[name*="qty" i]'
  };

  function parseMoney(text) {
    // يطلع رقم من "EGP 300.00"
    const num = (text || '').replace(/,/g, '').match(/(\d+(\.\d+)?)/);
    return num ? parseFloat(num[1]) : null;
  }

  function getSelectedQty() {
    const radio = document.querySelector(SELECTORS.qtyChecked);
    if (radio && radio.value) {
      const n = parseFloat(radio.value);
      if (!isNaN(n) && n > 0) return n;
    }

    const sel = document.querySelector(SELECTORS.qtySelect);
    if (sel && sel.value) {
      const n = parseFloat(sel.value);
      if (!isNaN(n) && n > 0) return n;
    }

    // fallback: أحيانًا values بتكون "50 pcs" في label
    // نحاول نقرأ label للـ checked radio لو موجود
    const anyChecked = document.querySelector('input[type="radio"]:checked');
    if (anyChecked) {
      const id = anyChecked.id;
      const lbl = id ? document.querySelector(`label[for="${CSS.escape(id)}"]`) : null;
      const t = lbl ? lbl.textContent : '';
      const m = (t || '').match(/(\d+)/);
      if (m) {
        const n = parseFloat(m[1]);
        if (!isNaN(n) && n > 0) return n;
      }
    }

    return null;
  }

  function formatUnitPrice(value) {
    // لو رقم قريب من integer نخليه integer
    if (Math.abs(value - Math.round(value)) < 0.02) return `${Math.round(value)}`;
    // غير كده نخليه رقم واحد بعد العلامة
    return `${(Math.round(value * 10) / 10).toFixed(1)}`;
  }

  function ensureUnitBadge() {
    const row = document.querySelector(SELECTORS.priceRow);
    const main = document.querySelector(SELECTORS.mainPrice);
    if (!main) return null;

    let badge = document.querySelector(SELECTORS.unitPrice);
    if (badge) return badge;

    // لو مش موجود، ننشئه جنب السعر
    badge = document.createElement('span');
    badge.className = 'stickit-unit-price';
    badge.textContent = 'EGP — / sticker';

    if (row) {
      row.appendChild(badge);
    } else {
      // fallback: حطه بعد السعر الرئيسي
      main.insertAdjacentElement('afterend', badge);
    }
    return badge;
  }

  function updateUnitPrice() {
    const main = document.querySelector(SELECTORS.mainPrice);
    const badge = ensureUnitBadge();
    if (!main || !badge) return;

    const total = parseMoney(main.textContent);
    const qty = getSelectedQty();

    if (!total || !qty) {
      // لو لسه Shopify ما حدّثش السعر/الاختيار، خليه مخفي مؤقتًا
      badge.style.display = 'none';
      return;
    }

    const unit = total / qty;
    const v = formatUnitPrice(unit);

    badge.style.display = '';
    badge.textContent = `EGP ${v} / sticker`;
  }

  function pulse(el) {
    if (!el) return;
    el.classList.remove('stickit-pulse');
    void el.offsetWidth;
    el.classList.add('stickit-pulse');
  }

  function setup() {
    const form = document.querySelector(SELECTORS.form) || document;

    // 1) اعرضه من أول الصفحة
    updateUnitPrice();
    // 2) إعادة محاولة بعد شوية لأن Shopify ساعات يحدّث السعر متأخر
    setTimeout(updateUnitPrice, 150);
    setTimeout(updateUnitPrice, 400);

    // 3) تحديث مع أي تغيير
    form.addEventListener('change', function () {
      updateUnitPrice();
      pulse(document.querySelector(SELECTORS.mainPrice));
      pulse(document.querySelector(SELECTORS.unitPrice));
    }, true);

    // 4) لو السعر اتغير بالـ AJAX
    const main = document.querySelector(SELECTORS.mainPrice);
    if (main) {
      const obs = new MutationObserver(() => {
        updateUnitPrice();
        pulse(main);
        pulse(document.querySelector(SELECTORS.unitPrice));
      });
      obs.observe(main, { childList: true, characterData: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
